export default {
  GET_ROLE_LIST: '/manage/userRole/findList',
  GET_ALL_AUTH: '/manage/resource/findAll',
  GET_ROLE_DETAILS: '/manage/userRole/detail',
  SAVE_ROLE: '/manage/userRole/save',
  UPDATE_ROLE: '/manage/userRole/update',
  EXPORT_LIST: '/manage/userRole/exportList',
  FILTER_ROLE: '/auth/userRole/findFilter',
  FIND_FILTER_ROLE: '/auth/userRole/findFilterRoles'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/role.js